import { Injectable } from '@angular/core'
import { map } from 'rxjs'
import { ProductItemTypeModel } from 'src/domain/models/product-item.model'
import { ProductItemRepository } from 'src/domain/repositories/product-item.repository'
import { DefaultResultData } from '../entities/base.entity'
import { CheckDuplicateItemCodeTypeEntity, ProductItemTypeEntity } from '../entities/product-item.entity'
import { CheckDuplicateItemCodeMapper } from '../mappers/product-item/check-duplicate-item-code.mapper'
import { ProductItemMapper } from '../mappers/product-item/product-item.mapper'

@Injectable({
	providedIn: 'root',
})
export class ProductItemImplementationRepository extends ProductItemRepository {
	checkDuplicateItemCodeMapper = new CheckDuplicateItemCodeMapper()
	productItemMapper = new ProductItemMapper()

	GetProductItemByProductId(params: { id: number }) {
		return this.get<DefaultResultData<ProductItemTypeEntity[]>>(
			`api/ProductItems/GetProductItemByProductId/${params.id}`,
		).pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.productItemMapper.mapFrom(item)
				})
			}),
		)
	}

	DeleteProductItem(params: { itemCode: string; productId: number }) {
		return this.post<any>(`api/productItems/deleteProductItem/${params.itemCode}/product/${params.productId}`)
	}

	CheckDuplicateItemCode(params: { itemCode: string }) {
		return this.get<CheckDuplicateItemCodeTypeEntity>(
			`api/ProductItems/CheckDuplicateItemCode?code=${params.itemCode}`,
		).pipe(
			map((response) => {
				return this.checkDuplicateItemCodeMapper.mapFrom(response)
			}),
		)
	}

	PostProductItem(params: { model: ProductItemTypeModel }) {
		return this.post<boolean>(`api/ProductItems`, params.model)
	}
}
